export class PriceDelivery {
   public static PRICE_ALTA_DIR_CONTACTO = 9;
   public static PRICE_ALTA_DIR_OTRADIR = 9;
   public static PRICE_ALTA_DIR_CORREOS = 6;
   public static PRICE_PORTA_DIR_CONTACTO = 3;
   public static PRICE_PORTA_DIR_OTRADIR = 3;
}
